<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-5 header-internal-section">
    <a (click)="back()"><div class="p-2 ms-3"><i class="bi bi-chevron-left align-middle"></i></div></a>
    <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center">Mi Contraseña</h1></div>
  </div>

  <div class="row-cols-12 m-2 mt-0 text-internal-section">
    <div class="row p-3 mb-0 align-items-center">
      <div class="col-12 mb-0">
        <label class="form-label barlow-bold">Ingresá tu nueva contraseña</label>
      </div>

      <form [formGroup]="form" (ngSubmit)="submit()">
        <!-- Password -->
        <div class="mb-3 mt-2 text-start position-relative">
          <input
            [type]="showPwd1() ? 'password' : 'text'"
            class="form-control has-icon"
            id="password"
            formControlName="password"
            placeholder="Contraseña"
            autocomplete="new-password"
            (focus)="showTips.set(true)"
          />
          <button
            type="button"
            class="toggle-visibility"
            aria-label="Mostrar/ocultar contraseña"
            (click)="togglePwd(1)"
          >
            <i class="bi" [class.bi-eye]="!showPwd1()" [class.bi-eye-slash]="showPwd1()"></i>
          </button>

          @if (form.controls.password.touched && form.controls.password.errors?.['required']) {
            <div class="alert-danger" role="alert"><small class="alert">Contraseña es requerida</small></div>
          }
          @if (form.controls.password.touched && form.controls.password.errors?.['minlength']) {
            <div class="alert-danger" role="alert"><small class="alert">La clave debe contener mínimo 6 caracteres.</small></div>
          }
        </div>

        <!-- Confirmación -->
        <div class="col-12 mb-0"><label class="form-label">Repetí otra vez tu nueva contraseña</label></div>
        <div class="mb-3 mt-2 text-start position-relative">
          <input
            [type]="showPwd2() ? 'password' : 'text'"
            class="form-control has-icon"
            id="password2"
            formControlName="password2"
            placeholder="Repetir contraseña"
            autocomplete="new-password"
            (focus)="showTips.set(true)"
          />
          <button
            type="button"
            class="toggle-visibility"
            aria-label="Mostrar/ocultar contraseña"
            (click)="togglePwd(2)"
          >
            <i class="bi" [class.bi-eye]="!showPwd2()" [class.bi-eye-slash]="showPwd2()"></i>
          </button>

          @if (form.controls.password2.touched && form.controls.password2.errors?.['required']) {
            <div class="alert-danger" role="alert"><small class="alert">Repetir Contraseña es requerida</small></div>
          }
          @if (mismatch()) {
            <div class="alert-danger" role="alert"><small class="alert">Las contraseñas deben coincidir.</small></div>
          }
        </div>

        <!-- Requisitos -->
        @if (showTips()) {
          <div class="alert alert-info" role="alert">
            <small>
              La clave debe tener al menos:
              <br />
              <span [class.req-ok]="lengthOk()" [class.req-ko]="!lengthOk()">• 6 caracteres</span><br />
              <span [class.req-ok]="upperOk()"  [class.req-ko]="!upperOk()">• Una mayúscula</span><br />
              <span [class.req-ok]="lowerOk()"  [class.req-ko]="!lowerOk()">• Una minúscula</span><br />
              <span [class.req-ok]="digitOk()"  [class.req-ko]="!digitOk()">• Un número</span>
            </small>
          </div>
        }

        <!-- Error general -->
        @if (error()) {
          <div class="alert alert-danger mt-2" role="alert">
            <small>{{ error() }}</small>
          </div>
        }

        <div class="d-grid mt-4 mb-3 pb-3 justify-content-around">
          <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="isBusy() || !form.touched">
            {{ isBusy() ? 'Cargando...' : 'Cambiar Contraseña' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>